/* 電話番号 */
import React, { useState, useCallback } from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
var TelInput = function (_a) {
    var label = _a.label, need = _a.need, value = _a.value, message = _a.message, help_msg = _a.help_msg, disabled = _a.disabled;
    var _b = useState(value[0] ? value[0] : ''), tel01 = _b[0], setTel01 = _b[1];
    var _c = useState(value[1] ? value[1] : ''), tel02 = _c[0], setTel02 = _c[1];
    var _d = useState(value[2] ? value[2] : ''), tel03 = _d[0], setTel03 = _d[1];
    var handleChangeTel01 = useCallback(function (event) {
        setTel01(event.target.value);
    }, []);
    var handleChangeTel02 = useCallback(function (event) {
        setTel02(event.target.value);
    }, []);
    var handleChangeTel03 = useCallback(function (event) {
        setTel03(event.target.value);
    }, []);
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 3, className: "pr-0" },
                    React.createElement(Form.Control, { type: "NUMBER", onChange: handleChangeTel01, defaultValue: tel01, disabled: disabled })),
                React.createElement(Col, { xs: 1, className: "d-flex align-items-center justify-content-center" }, "\uFF0D"),
                React.createElement(Col, { xs: 3, className: "p-0" },
                    React.createElement(Form.Control, { type: "NUMBER", onChange: handleChangeTel02, defaultValue: tel02, disabled: disabled })),
                React.createElement(Col, { xs: 1, className: "d-flex align-items-center justify-content-center" }, "\uFF0D"),
                React.createElement(Col, { xs: 3, className: "p-0" },
                    React.createElement(Form.Control, { type: "NUMBER", onChange: handleChangeTel03, defaultValue: tel03, disabled: disabled }))),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message })) }));
};
export default TelInput;
